import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-down-arrow-disabled",
  "use": "ic-down-arrow-disabled-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"ic-down-arrow-disabled\">\n    <path fill=\"rgba(0, 0, 0, 0.38)\" fill-rule=\"evenodd\" d=\"M6.207 7h5.586c.276 0 .5.224.5.5 0 .133-.053.26-.147.354l-2.792 2.792c-.196.196-.512.196-.708 0L5.854 7.854c-.196-.196-.196-.512 0-.708.093-.093.22-.146.353-.146z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol